import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-required-forms',
  templateUrl: './tryout-required-forms.component.html',
  styleUrls: ['./tryout-required-forms.component.css']
})
export class TryoutRequiredFormsComponent implements OnInit {
  @Input() NoOfTotalRequiredForms: string;
  @Output() getFormsEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  getForms(value) {
    this.getFormsEvent.emit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-required-forms/tryout-required-forms.component.ts